import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule, Routes } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserSelectComponent } from './user-select/user-select.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PasswordChangeDialogComponent } from './password-change-dialog/password-change-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FieldSelectComponent } from './field-select/field-select.component';
import { SharedModule } from '@app/shared/shared.module';
import { FieldEditComponent } from './field-edit/field-edit.component';
import { CodeCreateComponent } from './code-create/code-create.component';
import { CodeSelectComponent } from './code-select/code-select.component';
import { CodeDetailComponent } from './code-detail/code-detail.component';
import { CodeEditComponent, CodeEditDialogDeleteComponent } from './code-edit/code-edit.component';
import { C } from '@angular/cdk/keycodes';
import { MatSortModule } from '@angular/material/sort';

const routes: Routes = [
  {
    path: 'register',
    component: UserEditComponent
  },
  {
    path: 'users/:person_id/edit',
    component: UserEditComponent
  },
  {
    path: 'users/:person_id',
    component: UserDetailComponent
  },
  {
    path: 'users',
    component: UserSelectComponent
  },
  {
    path: 'fields',
    component: FieldSelectComponent
  },
  {
    path: 'fields/edit/:application_field_id',
    component: FieldEditComponent
  },
  {
    path: 'codes',
    component: CodeSelectComponent
  },
  {
    path: 'code/create',
    component: CodeCreateComponent
  },
  {
    path: 'codes/:code_id',
    component: CodeDetailComponent
  },
  {
    path: 'codes/:code_id/edit',
    component: CodeEditComponent
  }
]

@NgModule({
  declarations: [
    UserEditComponent, 
    UserSelectComponent, 
    UserDetailComponent, 
    PasswordChangeDialogComponent, 
    FieldSelectComponent, 
    FieldEditComponent,
    CodeSelectComponent,
    CodeCreateComponent,
    CodeDetailComponent,
    CodeEditComponent,
    CodeEditDialogDeleteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatToolbarModule,
    MatTableModule,
    MatSortModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatSnackBarModule,
    SharedModule
  ]
})
export class AdminModule { }
